import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
import { BrandSchemeEntityExtensionClass, IBrandSchemeEntity } from './entities/brand-scheme-entity';

// @ts-ignore
function brandSchemeQuery(brandSchemeId?: string): DataServiceQuery {
    const key = brandSchemeId ? { BrandSchemeId: brandSchemeId } : null;
    return new DataServiceQuery('BrandScheme', 'BrandSchemeEntity', BrandSchemeEntityExtensionClass, key);
}

export function createGetBrandSchemesByIdsInput(queryResultSettings: IQueryResultSettings, brandSchemeIds: string[]): IDataServiceRequest {
    const query = brandSchemeQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetBrandSchemesByIds',
        true,
        BrandSchemeEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IBrandSchemeEntity' },
        { brandSchemeIds: brandSchemeIds }
    );
}

export function getBrandSchemesByIdsAsync(context: IContext, brandSchemeIds: string[]): AsyncResult<IBrandSchemeEntity[]> {
    const request = createGetBrandSchemesByIdsInput(context.queryResultSettings || {}, brandSchemeIds);
    return callActionOrExecute<IBrandSchemeEntity[]>(request, context.callerContext);
}
